import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useBookingButtonClickHandler } from 'shared/hooks/useBookingButtonClickHandler';
import { getOfferCustomUrl } from 'shared/selectors/analytics';
import { selectOfferBookingEnabled, selectOfferBookingLoading } from 'shared/selectors/newbuildingBrokerOfferBooking';

export const NewbuildingBrokerOfferBookingButtonContainer: React.FC = () => {
  const offerBookingEnabled = useSelector(selectOfferBookingEnabled);
  const offerBookingLoading = useSelector(selectOfferBookingLoading);
  const gaLabel = useSelector(getOfferCustomUrl);

  const bookingButtonClickHandler = useBookingButtonClickHandler('offer_card_main_button', gaLabel);

  if (!offerBookingEnabled) {
    return null;
  }

  return (
    <Button fullWidth theme="fill_secondary" loading={offerBookingLoading} onClick={bookingButtonClickHandler}>
      Заявка на бронирование
    </Button>
  );
};
